<div
  class="slds-modal__content slds-p-around_medium custom"
  style=""
  id="modal-content-id-1"
  [ngClass]="{ custom: type === 'custom' }"
>
  <ng-content></ng-content>
</div>
